import { z } from 'zod';

export interface Arrangement {
    productId: string;
    bannerId: string;
    termCode: string; // 202410 202420 - vår høst
    campusCode: string; // O B R T F  - Oslo, Bergen, Stavanger, Trondheim, Fjernundervisning
    studentType: string; // 1 2 3 - årstall du starter på
    residenceCode: string; // Heltid Deletid
}

export interface AddToCartRequest {
    arrangementBannerId: string;
}

export interface SignInRequest {
    currentUrl: string;
}

export interface BiaxCartItem {
    type: string;
    name: string;
    category: string;
    bannerId: string;
    termCode: string;
    campusCode: string;
    residenceCode: string;
    credits: string;
    language: string;
    studentType: string;
    productId: number;
}

export interface BiaxCartResponse {
    items: BiaxCartItem[];
    biaxCartDetailPageUrl?: string;
}

export interface RedirectToBiax {
    url: string;
}

export interface AddToCartResponse {
    contactId: string;
    bannerIds: string[];
}

export interface Programme {
    name: string | null;
    hideApplyButton: boolean;
    whenCanIApply: boolean;
    whenCanIApplyUrl: string;
    campuses: string[];
    credits: number;
    teachingLanguage: string;
    courseLoad: string;
    arrangements: Arrangement[] | null;
    startDate: string | null;
    urlSchedule: string | null;
    hasPriceAndTuitionFeeBlock: boolean;
    isActive: boolean;
    isCourse: boolean;
    price: string;
}

export const addToCartFormScheema = z.object({
    campus: z.string().nonempty('cart:campusValidator'),
    term: z.string().nonempty('cart:termValidator'),
    residence: z.string().nonempty('cart:studyloadValidator'),
    studentType: z.string({
        message: 'cart:secondandthirdValidator',
    }),
});

export type AddToCartForm = z.infer<typeof addToCartFormScheema>;

export interface MenuProperties {
    iconColor: 'white' | 'primary';
    productSearchUrl: string;
}
